import { useMutation } from "@tanstack/react-query";
import { message, Input, Spin, Button } from "antd";

import Text from "antd/es/typography/Text";
import { Form } from "antd/es";
import { createPartnerMutation } from "../../services/client/@tanstack/react-query.gen";
import { useIsViewer } from "../../hooks/useIsViewer";
import { DisableForViewer } from "../../components/common/DisableForViewer";

export const CreateAndRegisterPartnerForm = () => {
  const isViewer = useIsViewer();
  const createPartner = useMutation({
    ...createPartnerMutation(),
    onSuccess: () => {
      message.success(
        "Partner created! Invite its first user from the Identities tab.",
      );
    },
    onError: () => {
      message.error("Failed to create partner");
    },
  });

  const createPartnerOnSubmit = async (
    partnerId: string,
    partnerName: string,
  ) => {
    await createPartner.mutateAsync({
      body: {
        partner_id: partnerId,
        name: partnerName,
      },
      headers: {
        Authorization: `Bearer ${localStorage.getItem("admin-token")}`, // The admin-token is not used per default so we need to explicitly set it
      },
    });
  };

  return (
    <div className="mt-4 w-full max-w-md">
      <Text className="my-0 font-bold">Create Partner</Text>
      <Text className="text-gray-400 my-0 block mb-4">
        Create a new partner. Invite its first user afterwards from the
        Identities tab.
      </Text>

      <Form
        layout="vertical"
        disabled={isViewer}
        onFinish={(values) => {
          createPartnerOnSubmit(values.partnerId, values.partnerName);
        }}
      >
        <Form.Item
          name="partnerName"
          label="Partner Name"
          rules={[{ required: true, message: "Please input the partner name" }]}
        >
          <Input placeholder="Partner Name" />
        </Form.Item>

        <Form.Item
          name="partnerId"
          label="Partner ID"
          rules={[{ required: true, message: "Please input the partner ID" }]}
        >
          <Input placeholder="Partner ID" />
        </Form.Item>

        <Form.Item>
          <DisableForViewer>
            <Button
              type="primary"
              htmlType="submit"
              className="w-full mt-2 rounded"
              disabled={createPartner.isPending}
            >
              {createPartner.isPending ? (
                <Spin size="small" />
              ) : (
                "Create Partner"
              )}
            </Button>
          </DisableForViewer>
        </Form.Item>
      </Form>
    </div>
  );
};

export default CreateAndRegisterPartnerForm;
